import React, { useState, useEffect } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import CodLeftPanel from "../include/CodLeftPanel";
import Global from "../../APIConfig";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import AuthUser from "../../AuthUser";
import ListLoader from "../Loaders/ListLoader";
import Select from 'react-select';
import { Button } from "react-bootstrap";

function HubCOD() {
    let navigate = useNavigate();
    const location = useLocation();
    const { headers1, headers2, logout } = AuthUser();
    const [Loading, setLoading] = useState(true);
    const [pendingBalance, setPendingBalance] = useState(0);
    const [paidBalance, setPaidBalance] = useState(0);
    const [totalShipment, setTotalShipment] = useState(0);
    const [driverlist, setDriverlist] = useState([]);
    const [selectedDriver, setSelectedDriver] = useState(null);
    const [hubList, setHubList] = useState([]);
    const [selectedHub, setSelectedHub] = useState(null);
    const [shipmentList, setShipmentList] = useState([]);
    const [checkedItems, setCheckedItems] = useState([]);
    const [BtnLoading, setBtnLoading] = useState(false);
    const [subtotal, setSubtotal] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState('Cash');
    const [gDefaultCurrency, setGDefaultCurrency] = useState('$');
    const [userdata, setUserdata] = useState('');
    const items = JSON.parse(localStorage.getItem('user'));

    useEffect(() => {
        GetHubList();
         setUserdata(items);
    }, []);

    useEffect(() => {
        // Calculate subtotal whenever checkedItems changes
        const newSubtotal = shipmentList
            .filter(item => checkedItems.includes(item.transaction_id))
            .reduce((sum, item) => sum + parseFloat(item.total_amount || 0), 0);
        setSubtotal(newSubtotal);
    }, [checkedItems, shipmentList]);

    const GetHubList = () => {
        setLoading(true);
        axios({
            method: 'post',
            url: Global.baseUrl + 'HublistCod',
            headers: headers1,
            data: {
                usertype:items.usertype,
                hubid:items.id
            }
        })
        .then(function (response) {
            if (response.data.status == 200) {
                const data = response.data.value;
                setHubList(data);
            }
            setLoading(false);
        })
        .catch(function (error) {
            if (error.response?.status == 401) {
                toast.error(error.response.statusText);
            }
            setLoading(false);
        });
    }

    const handleHubChange = (selectedOption) => {
        setSelectedHub(selectedOption);
        setSelectedDriver(null); // Reset driver when hub changes
        if (selectedOption) {
            GetMessangerList(selectedOption.value);
        } else {
            setDriverlist([]);
        }
    };

    const GetMessangerList = (hubId) => {
        setLoading(true);
        axios({
            method: 'post',
            url: Global.baseUrl + 'MessengerlistByhubid',
            headers: headers1,
            data: {
                hubid: hubId
            }
        })
        .then(function (response) {
            if (response.data.status == 200) {
                const data = response.data.value;
                setDriverlist(data);
            }
            setLoading(false);
        })
        .catch(function (error) {
            if (error.response?.status == 401) {
                toast.error(error.response.statusText);
            }
            setLoading(false);
        });
    }

    const handleMessengerChange = (selectedOption) => {
        setSelectedDriver(selectedOption);
    };

    const GetMessangerShipmentList = () => {
        if (!selectedHub) {
            toast.error("Please select Hub.");
            return;
        }
        setLoading(true);
        setCheckedItems([]); // Reset checked items when fetching new list
        setSubtotal(0); // Reset subtotal
        axios({
            method: 'post',
            url: Global.baseUrl + 'hubcodpendinglist',
            headers: headers1,
            data: {
                hubid: selectedHub.value
            }
        })
        .then(function (response) {
            if (response.data.status == 200) {
                setShipmentList(response.data.value);
                setPendingBalance(response.data.totalPendingAmount || 0);
                setPaidBalance(response.data.totalPaidAmount || 0);
                setTotalShipment(response.data.totalShipments || 0);
                setGDefaultCurrency(response.data.gDefaultCurrency || '$');
            } else {
                toast.warn(response.data.message);
            }
            setLoading(false);
        })
        .catch(function (error) {
            if (error.response?.status == 401) {
                toast.error(error.response.statusText);
            }
            setLoading(false);
        });
    }

    const handleCheckboxChange = (event, slip_no) => {
        if (event.target.checked) {
            setCheckedItems(prev => [...prev, slip_no]);
        } else {
            setCheckedItems(prev => prev.filter(item => item !== slip_no));
        }
    };

    const handleSelectAllChange = (event) => {
        if (event.target.checked) {
            setCheckedItems(shipmentList.map(item => item.transaction_id));
        } else {
            setCheckedItems([]);
        }
    };

    const handleScan = (e) => {
        const slipno = e.target.value.trim();
        if (!slipno) return;

        const foundShipment = shipmentList.find(ship => ship.transaction_id === slipno);
        if (foundShipment && !checkedItems.includes(slipno)) {
            setCheckedItems(prev => [...prev, slipno]);
            e.target.value = ''; // Clear the input after successful scan
            toast.success(`AWB #${slipno} added to collection`);
        }
    };

    const SubmitCod = () => {
        if (checkedItems.length === 0) {
            toast.warn('Please select at least one shipment!');
            return;
        }

        setBtnLoading(true);
        axios({
            method: 'post',
            url: Global.baseUrl + 'hubcodtransaction',
            headers: headers1,
            data: {
                usertype:items.usertype,
                transaction_id: checkedItems,
                hub_id: selectedHub.value,
                total_amount:subtotal,
                total_Shipment_count:checkedItems.length
                // messengerid: selectedDriver.value,
                // payment_method: paymentMethod
            }
        })
        .then(function (response) {
            if (response.data.status == 200) {
                toast.success('COD Transaction Successful');
                setTimeout(() => {
                    navigate('/HubCOD');
                    window.location.reload();
                }, 1000);
            } else {
                toast.error(response.data.error || 'Transaction failed');
            }
            setBtnLoading(false);
        })
        .catch(function (error) {
            setBtnLoading(false);
            if (error.response?.status == 401) {
                toast.error(error.response.statusText);
                logout();
                navigate('/');
            } else {
                toast.error('An error occurred during transaction');
            }
        });
    }

    const isChecked = (slip_no) => checkedItems.includes(slip_no);
    const allChecked = shipmentList.length > 0 && checkedItems.length === shipmentList.length;

    return (
        <>
            <CodLeftPanel />
            <main className='home-section'>
                <ToastContainer />
                <Header />
                <section className="my-3">
                    <div className="row">
                        <div className="col-12 col-md">
                            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                                <div className="d-block mb-4 mb-md-0">
                                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                                        <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                                            <li className="breadcrumb-item">
                                                <a href="/Admin-Dash">
                                                    <i className="bx bx-home text-primary-400 fs-6"></i>
                                                </a>
                                            </li>
                                            <li className="breadcrumb-item active" aria-current="page">Hub COD Collection</li>
                                        </ol>
                                    </nav>
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <button className="btn btn_nav btn-sm" type="button" onClick={() => navigate(-1)}>
                                                <i className="bx bx-arrow-back"></i>
                                            </button>
                                        </div>
                                        <div className="ps-2">
                                            <h2 className="h4">Hub COD Collection</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Selection Card */}
                    <div className="card mb-3">
                        <div className="card-body">
                            <div className="card mb-4 shadow-sm">
                                <div className="card-body">
                                    {/* <h5 className="card-title mb-4">COD Collection Details</h5> */}
                                    <div className="row g-3">
                                        <div className="col-md-5">
                                            <label className="form-label">Select Hub</label>
                                            <Select
                                                value={selectedHub}
                                                onChange={handleHubChange}
                                                options={hubList}
                                                placeholder="Select Hub"
                                                isClearable
                                            />
                                        </div>
                                        {/* <div className="col-md-5">
                                            <label className="form-label">Select Messenger (Driver)</label>
                                            <Select
                                                value={selectedDriver}
                                                onChange={handleMessengerChange}
                                                options={driverlist}
                                                placeholder="Select Driver"
                                                isDisabled={!selectedHub}
                                                isClearable
                                            />
                                        </div> */}
                                        <div className="col-md-2 d-flex align-items-end">
                                            <button 
                                                className="btn btn-primary w-100"
                                                onClick={GetMessangerShipmentList}
                                                disabled={!selectedHub}
                                            >
                                                Fetch
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Summary Cards */}
                    {shipmentList.length > 0 && (
                        <div className="row mb-4">
                            <div className="col-md-3 mb-3 mb-md-0">
                                <div className="card border-start border-primary border-4 h-100">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <h6 className="text-muted mb-1">All COD Pending Amount</h6>
                                                <h4 className="mb-0">{gDefaultCurrency}{pendingBalance.toFixed(2)}</h4>
                                            </div>
                                            <div className="ms-3">
                                                <i className="bx bx-time text-primary fs-1"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 mb-3 mb-md-0">
                                <div className="card border-start border-success border-4 h-100">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <h6 className="text-muted mb-1">Total Shipments</h6>
                                                <h4 className="mb-0">{totalShipment}</h4>
                                            </div>
                                            <div className="ms-3">
                                                <i className="bx bx-package text-success fs-1"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="card border-start border-info border-4 h-100">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <h6 className="text-muted mb-1">Selected Payments</h6>
                                                <h4 className="mb-0">{checkedItems.length}</h4>
                                            </div>
                                            <div className="ms-3">
                                                <i className="bx bx-check-circle text-info fs-1"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="card border-start border-info border-4 h-100">
                                    <div className="card-body">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <h6 className="text-muted mb-1">Selected Total Amount</h6>
                                                <h4 className="mb-0">{gDefaultCurrency}{subtotal.toFixed(2)}</h4>
                                            </div>
                                            <div className="ms-3">
                                                <i className="bx bx-credit-card text-info fs-1"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Scan Input */}
                    {shipmentList.length > 0 && (
                        <div className="card mb-4 shadow-sm">
                            <div className="card-body">
                                <label className="form-label">Scan AWB #</label>
                                <div className="input-group">
                                    <span className="input-group-text">
                                        <i className="bx bx-barcode"></i>
                                    </span>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        onChange={handleScan}
                                        placeholder="Enter or scan AWB number" 
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Shipments Table */}
                    {shipmentList.length > 0 && (
                        <div className="card mb-4 shadow-sm">
                            <div className="card-body p-0">
                                <div className="table-responsive">
                                    <table className="table table-hover mb-0">
                                        <thead>
                                            <tr>
                                                <th width="50">
                                                    <input 
                                                        className="form-check-input" 
                                                        type="checkbox" 
                                                        onChange={handleSelectAllChange} 
                                                        checked={allChecked}
                                                    />
                                                </th>
                                                <th>Unique ID</th>
                                                <th>Driver Code#</th>
                                                <th>Shipment Count</th>
                                                <th>Date</th>
                                                <th className="text-end">COD Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {shipmentList.map((ship, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <input 
                                                            className="form-check-input" 
                                                            type="checkbox" 
                                                            checked={isChecked(ship.transaction_id)}
                                                            onChange={(e) => handleCheckboxChange(e, ship.transaction_id)}
                                                        />
                                                    </td>
                                                    <td>{ship.transaction_id}</td>
                                                    <td>{ship.messenger_name}<br />{ship.messenger_code}</td>
                                                    <td>{ship.total_Shipment_count}</td>
                                                    <td>{ship.date} {ship.time}</td>
                                                    <td className="text-end">{gDefaultCurrency}{parseFloat(ship.total_amount || 0).toFixed(2)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan="5" className="text-end fw-bold">Subtotal:</td>
                                                <td className="text-end fw-bold">{gDefaultCurrency}{subtotal.toFixed(2)}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Payment Section */}
                    {shipmentList.length > 0 && (
                        <div className="">
                            <div className="">
                                <div className="row align-items-left">
                                    <div className="col-md-4">
                                        <button 
                                            className="btn btn-primary w-100"
                                            onClick={SubmitCod}
                                            disabled={BtnLoading || checkedItems.length === 0}
                                        >
                                            {BtnLoading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Processing...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="bx bx-money me-2"></i>
                                                    Collect COD Amount
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </section>
                <Footer />
            </main>
        </>
    );
}

export default HubCOD;